var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNose4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 51,
    viewBox: "0 0 60 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 33.9619C60 39.5175 54.2867 39.45 47 42.548C41.986 44.6798 36.7536 50.943 30 50.943C23.2464 50.943 17.014 43.6798 12 41.548C4.71332 38.45 0 39.5175 0 33.9619C0 24.5834 13.4315 33.9616 30 33.9616C46.5685 33.9616 60 24.5834 60 33.9619Z",
    fill: "#AD775C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0001,
    cy: 5.66038,
    rx: 16.4151,
    ry: 5.66038,
    fill: "#F8C1A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose4);
export default __webpack_public_path__ + "static/media/nose-4.2982e64792cdf0db15d139835b7a72a2.svg";
export { ForwardRef as ReactComponent };